import { Injectable } from '@angular/core';
import { HelperService } from '../shared/services/helper.service';
import { environment } from 'src/environments/environment';
import { HttpService } from '../shared/services/http.service';
import { TraceModel } from '../models/trace.model';

@Injectable()
export class TraceService {
    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    
    constructor(private httpService: HttpService) { }
    
    public CreateGiftCardOrderSalesTrace(params){
        this.URL = `${this.REQUEST_URL}/createGiftCardOrderSalesTrace`;
        return this.httpService.post<any>(this.URL, params);
    }

    public GetOrderSalesTraceByOrder(params) {
        this.URL = `${this.REQUEST_URL}/getOrderSalesTraceByOrder`;
        return this.httpService.post<TraceModel[]>(this.URL, params);
    }
}